// Sticky footer for mobile product page - only shows when scrolled past original buttons
(function () {
    function isMobile() {
        return window.innerWidth < 750;
    }

    let stickyWrapper = null;
    let originalButtonsContainer = null;
    let observer = null;
    let hasSeenButtonsInView = false;
    let syncTimeout = null;
    let isSyncing = false; // Flag to prevent sync loops

    function initializeStickyFooter() {
        if (!isMobile()) {
            cleanupStickyFooter();
            return;
        }

        if (stickyWrapper) {
            return;
        }

        const quantitySelector = document.querySelector('.product-form__quantity');
        const buyButtonsContainers = document.querySelectorAll('.product-form__atc-container');

        if (!quantitySelector || buyButtonsContainers.length === 0) {
            setTimeout(initializeStickyFooter, 100);
            return;
        }

        originalButtonsContainer = buyButtonsContainers[0];

        stickyWrapper = document.createElement('div');
        stickyWrapper.className = 'product-form__sticky-footer-wrapper';

        document.body.appendChild(stickyWrapper);

        const quantityClone = quantitySelector.cloneNode(true);
        stickyWrapper.appendChild(quantityClone);

        buyButtonsContainers.forEach(function (container) {
            const clone = container.cloneNode(true);
            stickyWrapper.appendChild(clone);
        });

        setupQuantitySync(quantitySelector, quantityClone, buyButtonsContainers);
        setupIntersectionObserver();
    }

    function setupIntersectionObserver() {
        if (!originalButtonsContainer) {
            return;
        }

        const options = {
            root: null,
            rootMargin: '0px',
            threshold: [0, 0.1, 0.5, 1.0]
        };

        observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                const rect = entry.boundingClientRect;

                if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
                    if (!hasSeenButtonsInView) {
                        hasSeenButtonsInView = true;
                    }
                }

                let shouldShowSticky = false;

                if (hasSeenButtonsInView && !entry.isIntersecting && rect.top < 0) {
                    shouldShowSticky = true;
                }

                if (stickyWrapper) {
                    if (shouldShowSticky) {
                        stickyWrapper.style.display = 'flex';
                        setTimeout(function () {
                            stickyWrapper.classList.add('is-visible');
                        }, 10);
                    } else {
                        stickyWrapper.classList.remove('is-visible');
                        setTimeout(function () {
                            if (!stickyWrapper.classList.contains('is-visible')) {
                                stickyWrapper.style.display = 'none';
                            }
                        }, 300);
                    }
                }
            });
        }, options);

        observer.observe(originalButtonsContainer);
    }

    function debounceSync(callback) {
        clearTimeout(syncTimeout);
        syncTimeout = setTimeout(callback, 100);
    }

    function setupQuantitySync(originalQuantity, clonedQuantity, originalButtonContainers) {
        const originalInput = originalQuantity.querySelector('.quantity__input');
        const clonedInput = clonedQuantity.querySelector('.quantity__input');

        if (!originalInput || !clonedInput) return;

        // Sync from clone to original with debounce
        clonedInput.addEventListener('change', function (e) {
            e.stopPropagation();
            if (isSyncing) return;

            debounceSync(function () {
                isSyncing = true;
                originalInput.value = clonedInput.value;
                originalInput.dispatchEvent(new Event('change', { bubbles: true }));
                setTimeout(function () {
                    isSyncing = false;
                }, 200);
            });
        });

        // Sync from original to clone (for cart updates, etc)
        originalInput.addEventListener('change', function () {
            if (isSyncing) return;

            debounceSync(function () {
                isSyncing = true;
                clonedInput.value = originalInput.value;
                setTimeout(function () {
                    isSyncing = false;
                }, 200);
            });
        });

        // Handle +/- buttons in clone with debounce
        const clonedButtons = clonedQuantity.querySelectorAll('.quantity__button');
        clonedButtons.forEach(function (button) {
            // Remove any existing listeners by replacing the button
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);

            newButton.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                if (isSyncing) return;

                const input = clonedQuantity.querySelector('.quantity__input');
                if (!input) return;

                const currentValue = parseInt(input.value) || 1;
                const min = parseInt(input.getAttribute('min')) || 1;
                const max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : null;
                const step = parseInt(input.getAttribute('step')) || 1;

                let newValue = currentValue;
                if (newButton.name === 'plus') {
                    newValue = currentValue + step;
                    if (max !== null && newValue > max) {
                        newValue = max;
                    }
                } else if (newButton.name === 'minus') {
                    newValue = currentValue - step;
                    if (newValue < min) {
                        newValue = min;
                    }
                }

                debounceSync(function () {
                    isSyncing = true;
                    input.value = newValue;
                    originalInput.value = newValue;
                    originalInput.dispatchEvent(new Event('change', { bubbles: true }));
                    setTimeout(function () {
                        isSyncing = false;
                    }, 200);
                });
            }, { once: false });
        });

        // Handle button clicks in cloned containers
        const clonedContainers = stickyWrapper.querySelectorAll('.product-form__atc-container');
        clonedContainers.forEach(function (clonedContainer, index) {
            const buttons = clonedContainer.querySelectorAll('button, a.button, .product-form__submit');
            buttons.forEach(function (button) {
                // Remove any existing listeners
                const newButton = button.cloneNode(true);
                button.parentNode.replaceChild(newButton, button);

                newButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    const originalContainer = originalButtonContainers[index];
                    if (originalContainer) {
                        const originalButton = originalContainer.querySelector('button[type="submit"], a.button, .product-form__submit');
                        if (originalButton) {
                            originalButton.click();
                        }
                    }
                }, { once: false });
            });
        });
    }

    function cleanupStickyFooter() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }

        if (stickyWrapper && stickyWrapper.parentNode) {
            stickyWrapper.remove();
            stickyWrapper = null;
        }

        originalButtonsContainer = null;
        hasSeenButtonsInView = false;
        isSyncing = false;
        clearTimeout(syncTimeout);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initializeStickyFooter();
        });
    } else {
        initializeStickyFooter();
    }

    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            cleanupStickyFooter();
            if (isMobile()) {
                initializeStickyFooter();
            }
        }, 250);
    });
})();